export const LogoutActions = {
  LogoutCallback: "logout-callback",
  Logout: "logout",
  LoggedOut: "logged-out",
};

export const LoginActions = {
  Login: "login",
  LoginCallback: "login-callback",
  LoginFailed: "login-failed",
};

export const StorageKeys = {
  RedirectTo: "redirectTo",
  HasLogin: "hasLogin",
  AuthId: "authId",
  RetrievalId: "retrievalId",
  AppId: "appId",
  ManagedAccountLifeId: "managedAccountLifeId",
  IsAccountSelected: "isAccountSelected",
};

const prefix = `/authentication`;

export const AuthenticationPaths = {
  DefaultLoginRedirectPath: "/",
  //  ApiAuthorizationClientConfigurationUrl: `/_configuration/${ApplicationName}`,
  authenticationPrefix: prefix,
  Login: `${prefix}/${LoginActions.Login}`,
  LoginFailed: `${prefix}/${LoginActions.LoginFailed}`,
  LoginCallback: `${prefix}/${LoginActions.LoginCallback}`,
  LogOut: `${prefix}/${LogoutActions.Logout}`,
  LoggedOut: `${prefix}/${LogoutActions.LoggedOut}`,
  LogOutCallback: `${prefix}/${LogoutActions.LogoutCallback}`,
};
